<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Message Center</ion-title>
        @if (debugMode) {
        <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    }
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- Split layout container: list on left, detail on right (wide screens) -->
    <div class="message-center-container">

        <!-- ================================================================ -->
        <!-- MESSAGE LIST PANEL                                                -->
        <!-- Always visible. On wide screens, takes left ~40% of the screen.  -->
        <!-- ================================================================ -->
        <div class="message-list-panel">
            <ion-list-header color="secondary" class="ion-text-wrap">
                {{messagesDefinedStr}}
                @if (unreadCount > 0) {
                    <ion-badge color="danger" class="unread-badge" data-test="unreadBadge">
                        {{unreadCount}} unread
                    </ion-badge>
                }
            </ion-list-header>

            <ion-list class="ion-padding" data-test="messages">
                @for (message of messages; track message.uid) {
                <ion-item-sliding>
                    <ion-item detail="true" data-test="message"
                            [class.message-selected]="isSelected(message)"
                            [class.message-unread]="message.status === 'unread'"
                            (click)="onMessageClick(message)" href="javascript:;">
                        <ion-icon [name]="getTypeIcon(message)" [color]="getTypeColor(message.type)"
                            slot="start" class="message-icon"></ion-icon>
                        <ion-label>
                            <span class="line1" [class.font-bold]="message.status === 'unread'">
                                {{message.title}}
                            </span><br />
                            <span class="line2">{{message.summary}}</span><br />
                            <span class="line3">{{formatDate(message.createdDate)}}</span>
                        </ion-label>
                        @if (message.priority === 'urgent') {
                            <ion-badge color="danger" slot="end">Urgent</ion-badge>
                        }
                        @if (message.priority === 'high') {
                            <ion-badge color="warning" slot="end">High</ion-badge>
                        }
                    </ion-item>
                    <ion-item-options>
                        <ion-button color="medium" (click)="onDismissMessage(message)" data-test="dismissMessage">
                            <ion-icon name="close-circle"></ion-icon>
                            Dismiss
                        </ion-button>
                    </ion-item-options>
                </ion-item-sliding>
                }

                @if (messages.length === 0) {
                    <ion-item>
                        <ion-label class="ion-text-center ion-padding">
                            <ion-icon name="checkmark-circle-outline" color="success"
                                style="font-size: 48px;"></ion-icon>
                            <p>You're all caught up! No messages.</p>
                        </ion-label>
                    </ion-item>
                }
            </ion-list>
        </div>

        <!-- ================================================================ -->
        <!-- MESSAGE DETAIL PANEL                                              -->
        <!-- Only visible on wide screens (>=768px via CSS).                   -->
        <!-- On narrow screens, the user navigates to the message detail page. -->
        <!-- ================================================================ -->
        <div class="message-detail-panel">
            @if (selectedMessage) {
                <div class="detail-content">
                    <div class="detail-header">
                        <div class="detail-title-row">
                            <ion-icon [name]="getTypeIcon(selectedMessage)"
                                [color]="getTypeColor(selectedMessage.type)"
                                class="detail-icon"></ion-icon>
                            <h2 data-test="detailTitle">{{selectedMessage.title}}</h2>
                        </div>
                        <div class="detail-meta">
                            <ion-badge [color]="getTypeColor(selectedMessage.type)">
                                {{selectedMessage.type | titlecase}}
                            </ion-badge>
                            @if (selectedMessage.priority === 'urgent' || selectedMessage.priority === 'high') {
                                <ion-badge [color]="selectedMessage.priority === 'urgent' ? 'danger' : 'warning'">
                                    {{selectedMessage.priority | titlecase}} Priority
                                </ion-badge>
                            }
                            <span class="detail-date">{{formatDate(selectedMessage.createdDate)}}</span>
                        </div>
                    </div>
                    <div class="detail-body" data-test="detailBody">
                        <p style="white-space: pre-line;">{{selectedMessage.body}}</p>
                    </div>
                    <div class="detail-actions">
                        @if (selectedMessage.actionLabel && selectedMessage.actionUrl) {
                            <ion-button color="primary" (click)="onActionClick(selectedMessage)"
                                data-test="detailAction">
                                {{selectedMessage.actionLabel}}
                            </ion-button>
                        }
                        <ion-button color="medium" fill="outline" (click)="onDismissMessage(selectedMessage)"
                            data-test="detailDismiss">
                            Dismiss
                        </ion-button>
                    </div>
                </div>
            } <!-- @else {
                <div class="detail-empty">
                    <ion-icon name="mail-open-outline" style="font-size: 64px; color: var(--ion-color-medium);"></ion-icon>
                    <p>Select a message to view details</p>
                </div>
            } -->
        </div>
    </div>
</ion-content>
